import * as React from 'react';
import { Route } from 'react-router';

import { supportedSubfolderLocaleCodes } from '@coursera-web/internationalization-lib';
import { StatsigProvider } from '@coursera-web/statsig';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import { inferPageNumberFromParams } from 'bundles/search-common/utils/eventingUtils';
import SeoSearchApp from 'bundles/seo-entity-page/components/SeoSearchApp';

const SeoSearchPage = loadOnRoute(() => import('bundles/seo-entity-page/components/SeoSearchPage'));

const SeoSearchAppWithStatsig = (props: React.ComponentProps<typeof SeoSearchApp>) => (
  <StatsigProvider>
    <SeoSearchApp {...props} />
  </StatsigProvider>
);

export default (
  <CourseraRoute
    path="/"
    component={SeoSearchAppWithStatsig}
    handle={{
      tracking: {
        data: (_, location) => {
          const currentPage = inferPageNumberFromParams(location?.query?.page);

          return {
            page: {
              segment: 'consumer',
              type: 'entity_query_page',
              pagination: {
                pageNumber: currentPage ? Number(currentPage) : 1,
              },
            },
          };
        },
      },
    }}
  >
    {/* Routes for subfolder localized EQP page */}
    {supportedSubfolderLocaleCodes.map((subfolderLocaleCode) => (
      <Route path={`${subfolderLocaleCode}/courses`} getComponent={SeoSearchPage} key={subfolderLocaleCode} />
    ))}
    <Route path="courses" getComponent={SeoSearchPage} />
    {/* This catch-all *, status=404 route is important for SSR. */}
    <Route path="*" component={NotFound} />
  </CourseraRoute>
);
